export default __webpack_public_path__ + "static/media/vroom2.dee3c74e.PNG";